import { Link, useNavigate } from 'react-router-dom';
import { fullName } from '@/lib/format';
import { useMe } from '@shared/hooks/use-me';
import { useAuthStore } from '@shared/stores/auth-store';
import { getTokenStore } from '@shared/api/token-store';
import { logout } from '@shared/api/auth';
import { ChatIcon } from './icons';
import { NotificationsBell } from './notifications-bell';
import { UserMenu } from './user-menu';

export function ClientHeader() {
  const { data: me } = useMe();
  const signOut = useAuthStore((s) => s.signOut);
  const navigate = useNavigate();

  const name = me ? fullName(me.firstName, me.lastName) : '';
  const email = me?.email ?? '';

  async function onSignOut() {
    try {
      await logout();
    } catch {
      /* ignore — we still clear locally */
    }
    getTokenStore().clear('client');
    signOut();
    navigate('/login', { replace: true });
  }

  return (
    <header className="sticky top-0 z-10 border-b border-gray-200 bg-white">
      <div className="flex w-full items-center justify-between gap-3 px-4 py-2.5 sm:px-6 sm:py-3">
        <div className="flex min-w-0 items-center gap-4 sm:gap-8">
          <Link to="/client/home" className="flex shrink-0 items-center gap-2 md:hidden">
            <img src="/ecregi_logo.png" alt="EcRegi" className="h-7 w-7 sm:h-8 sm:w-8" />
            <span className="text-base font-semibold text-brand-700 sm:text-lg">ECREGI</span>
          </Link>
        </div>

        <div className="flex shrink-0 items-center gap-1 sm:gap-2">
          <Link
            to="/client/chat"
            className="rounded-full p-2 text-gray-600 hover:bg-gray-100"
            aria-label="Chat"
          >
            <ChatIcon />
          </Link>
          <NotificationsBell />
          <UserMenu
            name={name}
            email={email}
            avatarUrl={me?.avatarUrl ?? undefined}
            onSignOut={onSignOut}
          />
        </div>
      </div>
    </header>
  );
}
